export default {
    PtImagePanel: {
        page: 'ページビュー',
        image: 'イメージビュー',
    },
};
